import { GetConfigResponse } from "../../../types/api/configurations.type";
import { QueryParam } from "../../../types/api/generic.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const ConfigurationsService = {
  async get(queryParams?: QueryParam[]): Promise<GetConfigResponse> {
    const params = queryParams ? createQueryParamString(queryParams, true) : "";
    const response = await httpClient.get<GetConfigResponse>(
      `v1/config${params}`,
    );
    return response;
  },
  async confirm(): Promise<void> {
    await httpClient.post("v1/config/confirm");
  },
};

export default ConfigurationsService;
